export default "__VITE_ASSET__BUMFVYnp__"